import React from 'react'
import PropTypes from 'prop-types'
import { Pane, SearchInput, majorScale, Select } from '@segment/react-ui-library'
import Events from './presentational/Events'
import Card from './presentational/Card'

const CustomersProfileEvents = ({ events, onSearch, onFilterChange }) => {
  return (
    <Card>
      <Pane white padding={majorScale(2)} borderBottom display='flex'>
        <SearchInput marginRight={majorScale(2)} flex='1' placeholder='Filter event history...'
          onChange={(e) => onSearch(e.target.value)} />
        <Select width={majorScale(14)} onChange={(e) => onFilterChange(e.target.value)}>
          <option value='all'>All</option>
          <option value='page'>Page</option>
          <option value='events'>Events</option>
        </Select>
      </Pane>
      <Events events={events} />
    </Card>
  )
}

CustomersProfileEvents.displayName = 'CustomersProfileEvents'

CustomersProfileEvents.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired
}

export default CustomersProfileEvents



// WEBPACK FOOTER //
// ./components/Customers/CustomersProfileEvents.js